export default "__VITE_ASSET__BZ$z1Ibx__"